(function($) {

	'use strict';

	function init(){
		$('.detailCibleBloc__names__item').on('click', switchCibleBloc);
	};

	function switchCibleBloc(){

		let item = $(this);

		if( !item.hasClass('active') ){

            let item_parent = item.parent().parent();

            item_parent.find('.detailCibleBloc__names__item.active, .detailCibleBloc__contents__item.active').removeClass('active');

            item_parent.find('.detailCibleBloc__contents__item[data-target="cible-' + item.data('cible') + '"]').addClass('active');

			item.addClass('active');

		}

	}

	$(document).ready(function() {
		if( $('.detailCibleBloc').length ){
			init();
		}
	});

})(jQuery);
